import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors, rt) => ({
  bottomSheet: {
    flex: 1,
    backgroundColor: colors.backgroundPrimaryInverse,
  },
  bottomSheetContentContainer: {
    flex: 1,
    backgroundColor: colors.backgroundPrimaryInverse,
  },
  content: {
    flex: 1,
    borderTopLeftRadius: theme.borderRadius.m,
    borderTopRightRadius: theme.borderRadius.m,
    backgroundColor: colors.backgroundPrimaryInverse,
    paddingTop: rt.insets.top + theme.spacing[2],
    paddingHorizontal: theme.spacing[5],
  },
  scrollView: {
    flex: 1,
  },
  scrollContent: {
    rowGap: theme.spacing[5],
    paddingBottom: rt.insets.bottom + theme.spacing[6],
  },
  header: {
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: theme.spacing[3],
    paddingBottom: theme.spacing[6],
  },
  sectionLabel: {
    textTransform: 'uppercase',
  },
  card: {
    backgroundColor: 'transparent',
    borderWidth: 1,
    borderColor: colors.borderInverse,
    borderRadius: theme.borderRadius.m,
    padding: theme.spacing[4],
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing[4],
  },
  rowContent: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing[4],
    flex: 1,
  },
  avatarBox: {
    width: 56,
    height: 56,
    borderRadius: theme.borderRadius.s,
    backgroundColor: colors.backgroundL3Inverse,
    alignItems: 'center',
    justifyContent: 'center',
  },
  serviceDivider: {
    height: 1,
    backgroundColor: colors.borderInverse,
    marginVertical: theme.spacing[4],
  },
  editButton: {
    width: 40,
    height: 40,
    borderRadius: theme.borderRadius.full,
    backgroundColor: colors.backgroundBrand,
    alignItems: 'center',
    justifyContent: 'center',
  },
  removeButton: {
    width: 40,
    height: 40,
    borderRadius: theme.borderRadius.full,
    borderWidth: 1,
    borderColor: colors.borderInverse,
    alignItems: 'center',
    justifyContent: 'center',
  },
}));
